// keep in sync with FeedbackTypes of internal/services/feedback_service.go
export const FEEDBACK_TYPES = ["bug", "suggestion", "other"] as const;
